import React, { useState, VoidFunctionComponent } from "react";
import { validateEmail } from "@/utils/responsive/utils";
import { Checkbox } from "@/components/responsive/commun/checkbox";
import { TextField } from "@/components/responsive/commun/text-field/textField";
import { TextArea } from "@/components/responsive/commun/text-area/textArea";

interface Props {
    isChecked: boolean,
    setIsChecked: (isChecked: boolean) => void,
    question: string,
    setQuestion: (question: string) => void,
    pseudo: string,
    setPseudo: (pseudo: string) => void,
    email: string,
    setEmail: (email: string) => void,
}

export const FormQuestion: VoidFunctionComponent<Props> = ({
    isChecked,
    setIsChecked,
    question,
    setQuestion,
    pseudo,
    setPseudo,
    email,
    setEmail
}) => {

    const [pseudoError, setPseudoError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [questionError, setQuestionError] = useState(false)
    const [checkedBoxError, setCheckedBoxError] = useState(false)

    const handleChangePseudo = (pseudo: string) => {
        setPseudo(pseudo)
        const trimmedPseudo = pseudo.replace(/\s/g, '');
        setCheckedBoxError(true)
        if (trimmedPseudo.length < 2) {
            setPseudoError(true)
        } else {
            setPseudoError(false)
        }
    }
    const handleChangeEmail = (email: string) => {
        setEmail(email)
        setCheckedBoxError(true)
        if (email.length == 0 || !validateEmail(email)) {
            setEmailError(true)
        } else {
            setEmailError(false)
        }
    }
    const handleChangeQuestion = (question: string) => {
        setQuestion(question)
        const trimmedQuestion = question.replace(/\s/g, '');
        setCheckedBoxError(true)
        if (trimmedQuestion.length >= 0 && trimmedQuestion.length < 10) {
            setQuestionError(true)
        } else {
            setQuestionError(false)
        }
    }
    const handleChangeCheckedBox = (isChecked: boolean) => {
        setIsChecked(isChecked)
        if (!isChecked) {
            setCheckedBoxError(true)
        } else {
            setCheckedBoxError(false)
        }
    }

    return (
        <div className='form'>
            <div className='form-question'>
                <TextArea
                    field='question'
                    label='Votre question* :'
                    bottomMessage={questionError && 'Veuillez saisir 10 caractères minimum'}
                    error={questionError}
                    value={question}
                    callback={(e: string) => handleChangeQuestion(e)}
                    placeholder='Quelles questions souhaitez-vous poser sur ce produit ? &#13;&#10;Quelles sont les informations que vous souhaitez avoir en tant que futurs acheteurs ?'
                />
            </div>
            <div className='form-pseudo'>
                <TextField
                    value={pseudo}
                    callback={(e) => handleChangePseudo(e)}
                    label='Votre pseudo* :'
                    error={pseudoError}
                    bottomMessage={pseudoError && 'Ce champ est obligatoire'}
                />
            </div>
            <div className='form-email'>
                <TextField
                    value={email}
                    callback={(e) => handleChangeEmail(e)}
                    label='Adresse e-mail* :'
                    error={emailError}
                    bottomMessage={emailError && 'Ce champ est obligatoire'}
                />
            </div>
            <div className={`form-checkbox ${!isChecked && checkedBoxError ? 'error' : ''}`}>
                <Checkbox
                    field='askQuestionCheck'
                    checked={isChecked}
                    callBack={() => handleChangeCheckedBox(!isChecked)}
                />
                <div className='text'>
                    <p>
                        BUT INTERNATIONAL traite les données recueillies afin que vous
                        puissiez poser vos questions à d'autres clients. Pour en savoir plus
                        sur la gestion de vos données personnelles{' '}
                        <a
                            href='https://www.but.fr/Common/Services/DonneesPersonnelles'
                            rel='noreferrer noopener'
                            target='_blank'
                        >
                            cliquez-ici.
                        </a>
                    </p>

                    {!isChecked && checkedBoxError && (
                        <p className='errorChecked'>
                            Vous devez accepter les conditions pour envoyer votre message
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};